import {createStyledAnimation, Duration, getDuration, PropertyFlowDescription} from '../../../transition';

export function scaleFadeFlowBuilder(duration: Duration): PropertyFlowDescription[] {
	const durationValue = getDuration(duration);
	return [
		{
			name: 'transform',
			duration: durationValue,
			initial: 'scale(0.9)',
			from: 'scale(0.9)',
			to: 'scale(1)',
			timingFunction: 'ease-in-out',
		},
	];
}

export const PopupAppearAnimation = createStyledAnimation('PopupAppearAnimation', scaleFadeFlowBuilder);
